import React, { Component } from 'react';
import axios from 'axios';
import { Link, type RouteComponentProps } from 'react-router-dom';
import store from '../../store/store';
import { classes } from './login';

interface userprops extends RouteComponentProps {}
class ForgotPassword extends Component<userprops> {
  state = {
    email: 'sony.sadi@gmail.com',
    errorMessage: '',
    user: {},
  };

  componentDidMount() {
    if (store.getState().auth.jwt) {
      this.props.history.push('/dashboard');
    }
  }

  render() {
    return (
      <div className={classes.container}>
        <div className={classes.imagebox}></div>
        <div className={classes.formBox}>
          <div className="flex flex-row h-screen items-center justify-center">
            <div className={classes.formContainer}>
              <div className={classes.heading}>
                <h2>Forgot Password</h2>
                <p className="mb-4 text-danger">{this.state.errorMessage} </p>
              </div>
              <div className="text-lg mb-5">Contact Admin to get new password</div>
              <div className="flex flex-nowrap justify-evenly">
                <div>
                  <span className="m-auto">
                    <Link to="/" className="forgot-pass">
                      Login
                    </Link>
                  </span>
                </div>
                <div>
                  <span className="m-auto">
                    <Link to="/register" className="forgot-pass">
                      Signup
                    </Link>
                  </span>
                </div>
              </div>
              {/* <form onSubmit={this.login}>
                <div>
                  <label htmlFor="email" className="block mb-2 text-lg font-bold">
                    Email
                  </label>
                  <input
                    type="text"
                    className="p-3 mb-3 w-full rounded"
                    placeholder="your-email@gmail.com"
                    id="email"
                    onChange={(e) => {
                      this.handleChange(e, 'email');
                    }}
                  />
                </div>

                <div className="flex flex-nowrap justify-evenly">
                  <div>
                    <span className="m-auto">
                      <Link to="/" className="forgot-pass">
                        Login
                      </Link>
                    </span>
                  </div>
                  <div>
                    <span className="m-auto">
                      <Link to="/register" className="forgot-pass">
                        Signup
                      </Link>
                    </span>
                  </div>
                </div>

                <input
                  type="submit"
                  value="Forgot Password"
                  className="bg-primary-red w-full py-3 mt-5 rounded-md text-white font-bold hover:cursor-pointer"
                />
              </form> */}
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleChange = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    this.setState({ [key]: e.target.value });
  };

  login = async (event: { preventDefault: () => void }) => {
    const that = this;
    event.preventDefault();
    await axios
      .post(`${process.env.REACT_APP_API_SERVER}/auth/forgot-password`, {
        email: that.state.email,
      })
      .then((res) => {
        // that.props.history.push("/check-email");
      })
      .catch((error) => {
        if (error.response) {
          this.setState({
            errorMessage: error.response.data.message[0].messages[0].message,
          });
        }
      });
  };
}

export default ForgotPassword;
